import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITenant } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

@Injectable()
export class TenantService extends ODataService<ITenant, number> {
    protected _endpoint = '/odata/Tenants';
    constructor(http: HttpClient) {
        super(http, MapperService.tenantMap);
    }

    public setActive(tenantIds: number[], active: boolean) {
        const payload = JSON.stringify({
            tenantIds: tenantIds,
            active: active,
        });

        return this._http
            .post(
                `${this._endpoint}/UiPath.Server.Configuration.OData.SetActive`,
                payload,
            );
    }
}
